import { render, staticRenderFns } from "./DashboardSulteng.vue?vue&type=template&id=7064b728&lang=pug"
import script from "./DashboardSulteng.vue?vue&type=script&lang=js"
export * from "./DashboardSulteng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports